const ChunkWhile = (arrData, callback) => {
  let chunk = [];
  let chunks = [];
  arrData?.forEach((value, index) => {
    if (index === 0) {
      chunk = [value];
    } else {
      if (callback(value, index, chunk)) {
        chunks.push(chunk);
        chunk = [value];
      } else {
        chunk.push(value);
      }
    }
  });
  if (chunk.length) {
    chunks.push(chunk);
  }
  return chunks;
};

const ChunkUser = (arrData) => {
  return ChunkWhile(arrData, (value, index, chunk) => {
    return value.author.id !== chunk[chunk.length - 1].author.id;
  });
};

const ChunkTime = (arrData) => {
  return ChunkWhile(arrData, (value, index, chunk) => {
    return (
      new Date(value.created_at).getDate() !==
      new Date(chunk[chunk.length - 1].created_at).getDate()
    );
  });
};

const GroupBy = (array, callback) => {
  return array.reduce(function (store, item) {
    var key = callback(item);
    var value = store[key] || [];
    store[key] = value.concat([item]);
    return store;
  }, []);
};

export { ChunkUser, ChunkTime, GroupBy };
